module.exports = __webpack_public_path__ + "static/17-beabb805150db471e77992d09dad8422.jpg";